<div class="container dialog-container" style="height: 95%;">

  <h2 mat-dialog-title class="blue-heading" align="center">Terms and Conditions</h2>

  <mat-dialog-content class="mat-typography">
    <b>Fisher's Responsibility: Archipelago will receive records from fishers and submit those records to the Department of Fisheries and Oceans (DFO) on behalf of the fishers. It is the fisher's responsibility to ensure that the reports have been submitted (confirmed by the issuance of confirmation numbers). It is the fisher's responsibility to ensure the content and timing of the report meets reporting, logbook, fishery notice, and licence conditions. Reports will only be accepted if the fisher has a valid account subscription for the report being generated. Accounts cannot be shared with another vessel as the account ID numbers are unique and assigned to a single vessel.</b>
    <br/>
    <b>Confidentiality: Rigid controls are in place to guard against unauthorized access to fishing and/or landing information. All information is encrypted and kept in strict confidence by Archipelago and delivered to DFO.</b>
    <br/><br/>
    <b>Click below for the full terms and conditions.</b>
    <br>

      @if (showPdf) {
        <button mat-button
          class="back-button"
          type="button"
          (click)="backToDialog()">
          <mat-icon>
            close
          </mat-icon>
        </button>
      }

      @if (showPdf) {
        <pdf-viewer
          [src]="path"
          [original-size]="false"
          style="width: 100%; height: 100%;">
        </pdf-viewer>
      }
    </mat-dialog-content>

    @if (isSmallScreen) {
      <button i18n mat-stroked-button
        type="submit"
        style="background-color: #3ebfb9; color: white; font-weight: bold; margin-top: 15px;"
        (click)="termsConditionsClick()">
            Terms & Conditions
    </button>

      <div style="display: flex; justify-content: space-evenly; margin-top: 10px">
        <button i18n mat-stroked-button
          type="submit"
          style="background-color: #005d87; color: white; font-weight: bold;"
          (click)="back()">
            Back
      </button>

        <button i18n mat-stroked-button
          type="submit"
          style="background-color: #ff6f61; color: white; font-weight: bold;"
          (click)="agree()">
            Accept
        </button>

      </div>
    } @else {
      <div style="display: flex; justify-content: space-evenly;">
        <button i18n mat-stroked-button
          type="submit"
          style="background-color: #005d87; color: white; font-weight: bold;"
          (click)="back()">
            Back
      </button>

        <button i18n mat-stroked-button
          type="submit"
          style="background-color: #3ebfb9; color: white; font-weight: bold;"
          (click)="termsConditionsClick()">
        Terms & Conditions
      </button>

        <button i18n mat-stroked-button
          type="submit"
          style="background-color: #ff6f61; color: white; font-weight: bold;"
          (click)="agree()">
            Accept
        </button>

      </div>
    }


